import { RedeemGenericVoucherTray } from '../../../domain/redeem-generic-voucher-tray';
import { CreateMarketingGenericVoucherPageItemApiModel, MarketingGenericVoucherTypeApiModel } from '@cxb/editor-stb-api';
import { mapperPipe, PlatformType, remainderMapper } from 'osn-shared';
import { backgroundImagesMapperDomainToApi } from '../../mapping/create-tray-domain-to-api';
import { localizedDataMapper } from '../../mapping/create-tray-api-domain-common';
import { MarketingGenericVoucherPageItemApiModel } from '@cxb/editor-stb-api/model/models';
import { commonMapper, mapApiModelImageWithPlatformToDomain } from '../../mapping/create-tray-api-to-domain';
import { RedeemGenericVoucherTrayFormViewModel } from './redeem-generic-voucher-tray-form-view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import { mapDomainImagesToPlatformLocalizedViewModelImage } from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import { localizedFormDataMapper } from '../create-tray-screen/mapping/create-tray-domain-vm-common';
import { mapViewModelImagesToDomainImages } from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'RedeemGenericVoucherTray'

/**
 * DOMAIN -> API
 */

// AXB-1175
export const mapDomainRedeemGenericVoucherTrayToApi = (
  tray: RedeemGenericVoucherTray,
  pageVersionId: string,
  tenantId?: string
): CreateMarketingGenericVoucherPageItemApiModel => {
  return remainderMapper(mapperPipe(tray, backgroundImagesMapperDomainToApi), () => ({
    pageVersionId,
    name: tray.titleEnglish,
    slug: pageVersionId,
    voucherType: MarketingGenericVoucherTypeApiModel.VoucherCode,
    buttonTextLocalized: localizedDataMapper(tray.buttonText),
    instructionsLocalized: localizedDataMapper(tray.instructionText),
    voucherBoxTextLocalized: localizedDataMapper(tray.voucherBoxText),
    mainTextLocalized: localizedDataMapper(tray.mainCtaText),
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */
// AXB-1175
export const mapApiRedeemGenericVoucherTrayToDomain = (tray: MarketingGenericVoucherPageItemApiModel): RedeemGenericVoucherTray => {
  return remainderMapper(mapperPipe(tray, commonMapper), () => ({
    type: 'RedeemGenericVoucherTray',
    buttonText: localizedDataMapper(tray.buttonTextLocalized),
    titleEnglish: tray.name,
    instructionText: localizedDataMapper(tray.instructionsLocalized),
    mainCtaText: localizedDataMapper(tray.mainTextLocalized),
    voucherBoxText: localizedDataMapper(tray.voucherBoxTextLocalized),
    backgroundImages: tray.backgroundImages.map(mapApiModelImageWithPlatformToDomain),
  }));
};

/**
 * DOMAIN -> VIEWMODEL
 */

// AXB-1175
export const mapDomainRedeemGenericVoucherTrayToViewModel = (tray: RedeemGenericVoucherTray): RedeemGenericVoucherTrayFormViewModel => {
  return {
    id: tray.id,
    name: tray.titleEnglish,
    type: TrayFormViewModelType.RedeemGenericVoucherTray,
    backgroundImages: mapDomainImagesToPlatformLocalizedViewModelImage(tray.backgroundImages),
    buttonText: localizedDataMapper(tray.buttonText),
    instructionText: localizedDataMapper(tray.instructionText),
    mainCtaText: localizedDataMapper(tray.mainCtaText),
    voucherBoxText: localizedDataMapper(tray.voucherBoxText),
  };
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapViewModelRedeemGenericVoucherTrayToDomain = (
  tray: RedeemGenericVoucherTrayFormViewModel,
  platformIds: Record<PlatformType, string>
): RedeemGenericVoucherTray => {
  return {
    id: tray.id,
    type: 'RedeemGenericVoucherTray',
    titleEnglish: tray.name,
    order: undefined,
    visible: undefined,
    draggable: true,
    backgroundImages: mapViewModelImagesToDomainImages(tray.backgroundImages, platformIds),
    buttonText: localizedFormDataMapper(tray.buttonText),
    voucherBoxText: localizedFormDataMapper(tray.voucherBoxText),
    mainCtaText: localizedFormDataMapper(tray.mainCtaText),
    instructionText: localizedFormDataMapper(tray.instructionText),
    platformIds: Object.values(platformIds),
  };
};
